import { CsvUploadWizard } from "./csv-upload-wizard"

export function CsvUploadField() {
	return (
		<>
			<div>
				<header className="space-y-1 text-sm">
					<div className="text-base font-medium">File upload</div>
					<div className="mb-6 text-secondary">
						Import Threads from a CSV file
					</div>
				</header>
				<div className="mt-4 overflow-hidden">
					<CsvUploadWizard />
				</div>
			</div>
		</>
	)
}
